<template>
  <div id="notFound" :class="{ light: !darkMode }">404 NOT FOUND</div>
</template>
<script lang="ts">
import { defineComponent } from "vue";
import store from "@/store";

export default defineComponent({
  name: "NotFound",
  computed: {
    darkMode() {
      return store.state.darkMode;
    },
  },
});
</script>
<style scoped>
#notFound {
  position: absolute;
  z-index: 100;
  right: 20px;
  bottom: 20px;
  font-size: 20px;
  border: solid 1px #ececec;
  border-radius: 5px;
  background: rgba(33, 33, 33, 0.8);
  backdrop-filter: blur(2px);
  box-shadow: 0 4px 15px rgba(33, 33, 33, 0.2);
  padding: 5px 10px;
}

#notFound.light {
  border-color: #212121;
  background: rgba(236, 236, 236, 0.8);
  box-shadow: 0 4px 15px rgba(236, 236, 236, 0.2);
}
</style>
